import React, { useState } from "react";
import { Gameboard } from "../components/gameboard/Gameboard";

const GamePage = () => {
    return (
    <div className="page game">
        <Gameboard></Gameboard>
    </div>
);
}

export { GamePage };
